export default "__VITE_ASSET__5$M4_PWQ__"